/**
 * G1. Двор: сетка 3×3 соседских детей, позвать троих; шанс согласия по
 * отношениям написан. Исход считает логика по Rng.
 */
import { t } from '@life/i18n';
import type { YardInput, YardState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Pick } from './ui/Pick';

export function Yard({ state, onInput }: MinigameScreenProps<YardInput, YardState>) {
  const [taps, setTaps] = useState<number[]>([]);
  return (
    <>
      <p class="hint">{t('ui.minigame.yard.rules', { n: state.taps, cells: state.cells, p: Math.round(state.p * 100) })}</p>
      <Pick
        grid
        label={t('ui.minigame.yard.label')}
        items={Array.from({ length: state.cells }, (_x, i) => ({ text: t('ui.minigame.yard.child', { n: i + 1 }) }))}
        max={state.taps}
        value={taps}
        onChange={setTaps}
      />
      <button type="button" class="btn accent block" disabled={taps.length === 0} onClick={() => onInput({ taps })}>
        {t('ui.minigame.yard.call')}
      </button>
    </>
  );
}
